import React, { useContext } from "react";
import {
  Paper,
  Divider,
  Box,
  Typography,
  makeStyles,
  Button
} from "@material-ui/core";
import { Sheet, SheetContent, LogoGGT, LogoGGV } from "../../components";
import { useTranslation } from "react-i18next";
import { BrandThemeContext } from "../../contexts";

const useClasses = makeStyles(theme => ({
  resultText: {
    fontSize: "3rem",
    textTransform: "uppercase",
    fontWeight: "700",
    color: theme.palette.common.black
  },
  introText: {
    marginBottom: "-1rem"
  }
}));

const AppointmentUnavailable = () => {
  const { t } = useTranslation();
  const classes = useClasses();
  const { themeName } = useContext(BrandThemeContext);

  return (
    <>
      <Sheet data-cy="appointment-unavailable">
        <SheetContent>
          <Box textAlign="center" pb={2}>
            <Box textAlign="center" pb={2}>
              {themeName === "GGT" && <LogoGGT />}
              {themeName === "GGV" && <LogoGGV />}
            </Box>
          </Box>
          <Box mb={2}>
            <Paper>
              <Box p={2} textAlign="center">
                <Typography variant="h6" component="p">
                  {t("appointment.unavailable.title")}
                </Typography>
                <Typography className={classes.resultText}>
                  {t("appointment.unavailable.status")}
                </Typography>
                <Typography align="center">
                  {t("appointment.unavailable.intro_text")}
                </Typography>
                <Box my={2}>
                  <Divider variant="middle" />
                </Box>
                <Typography paragraph>
                  {t("appointment.unavailable.faqs_title")}
                </Typography>
                <Button
                  fullWidth
                  variant="contained"
                  size="large"
                  color="default"
                  href="https://www.gogettested.com/"
                  rel="noopener"
                  target="_blank"
                >
                  {t("appointment.unavailable.button_view_faqs")}
                </Button>
              </Box>
            </Paper>
          </Box>
        </SheetContent>
      </Sheet>
    </>
  );
};

export { AppointmentUnavailable };
